<template>
  <div class="message">
    <div
      class="message-container animate__animated animate__bounce"
      :class="getClass"
      v-text="getContent"
    >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
      getContent: function() {
          if(this.content) {
              return "👏👏👏 Great Job";
          } else {
              return "😓 Better Luck Next Time 😓"
          }
      }, 
      getClass: function() {
          if(this.content) {
              return "correct";
          }else {
              return "wrong";
          }
      }
  },
  props: {
    content: Boolean,
  },
};
</script>

<style scoped>
.message {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
}

.message-container {
  padding: 10px;
  border-radius: 10px;
}
.wrong {
background: #e65072
}

.correct {
 background: #3da2e6;
}
</style>